(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["team-clamped-text"] && !Shopify.designMode) return;
  try {
    class TeamClampedText extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.team-clamped__content');
      this.textEl = this.querySelector('.team-clamped__text');
      this.toggle = this.querySelector('.team-clamped__toggle');
      if (!this.content || !this.textEl || !this.toggle) return;

      this.desktopLines = parseInt(this.dataset.desktopLines || '3', 10);
      this.mobileLines = parseInt(this.dataset.mobileLines || '3', 10);
      this.mql = window.matchMedia('(max-width: 767px)');

      this.toggle.addEventListener('click', () => this.toggleExpanded());
      this.mql.addEventListener('change', () => this.applyClamp());

      this.applyClamp();
    }

    get clampLines() {
      return this.mql.matches ? this.mobileLines : this.desktopLines;
    }

    applyClamp() {
      this.style.setProperty('--team-clamp-lines', String(this.clampLines));
      if (this.dataset.collapsed !== 'false') {
        this.dataset.collapsed = 'true';
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.textContent = this.toggle.dataset.labelMore;
      }
      requestAnimationFrame(() => this.checkOverflow());
    }

    checkOverflow() {
      this.style.setProperty('--team-clamp-lines', String(this.clampLines));
      if (this.dataset.collapsed === 'false') {
        this.toggle.hidden = false;
        return;
      }
      this.dataset.collapsed = 'false';
      const fullHeight = this.textEl.scrollHeight;
      this.dataset.collapsed = 'true';
      const lineHeight = parseFloat(getComputedStyle(this.textEl).lineHeight) || 24;
      const maxHeight = lineHeight * this.clampLines;
      this.toggle.hidden = !(fullHeight > maxHeight + 2);
    }

    toggleExpanded() {
      const expanded = this.dataset.collapsed === 'false';
      this.dataset.collapsed = expanded ? 'true' : 'false';
      this.toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      this.toggle.textContent = expanded
        ? this.toggle.dataset.labelMore
        : this.toggle.dataset.labelLess;
    }
  }

  if (!customElements.get('team-clamped-text')) {
    customElements.define('team-clamped-text', TeamClampedText);
  }
  } catch(e) { console.error(e); }
})();

})();
